import React, { useState, useEffect } from 'react';
import { useQuill } from 'react-quilljs';
import 'quill/dist/quill.snow.css'; // Import Quill styles
import Quill from 'quill';
import ImageResize from 'quill-image-resize';
import { db, storage } from '../../firebase/firebase';
import { ref as dbRef, push, set } from 'firebase/database';
import { ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage';
import { CircularProgress } from '@mui/material';

Quill.register('modules/imageResize', ImageResize);

export default function NewPost() {
    const [content, setContent] = useState([]);
    const [postTitle, setPostTitle] = useState('');
    const [loading, setLoading] = useState(false);
    const [prevImg, setPrevImg] = useState('')
    const [prevImgFile, setPrevImgFile] = useState(null);
    const { quill, quillRef } = useQuill({
        theme: 'snow',
        modules: {
            imageResize: {},
            toolbar: [
                [{ 'header': [1, 2, 3, 4, 5, 6, false] }],  // Header dropdown
                ['bold', 'italic', 'underline', 'strike'],  // Bold, italic, underline, strike
                [{ 'list': 'ordered' }, { 'list': 'bullet' }],  // Lists
                [{ 'script': 'sub' }, { 'script': 'super' }],  // Subscript/superscript
                [{ 'indent': '-1' }, { 'indent': '+1' }],  // Indent/outdent
                [{ 'direction': 'rtl' }],  // Text direction
                [{ 'size': ['small', false, 'large', 'huge'] }],  // Custom dropdown
                [{ 'color': [] }, { 'background': [] }],  // Dropdown with defaults from theme
                [{ 'font': [] }],
                [{ 'align': [] }],
                ['clean'],  // Remove formatting button
                ['link', 'image'],
            ],
        }
    });

    useEffect(() => {
        if (quill) {
            quill.getModule('toolbar').addHandler('image', imageHandler);
            quill.getModule('toolbar').addHandler('video', VideoHandler);
        }
    }, [quill]);

    const imageHandler = () => {
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/*');
        input.onchange = async () => {
            const file = input.files[0];
            if (file) {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = (e) => {
                    const range = quill.getSelection(true);
                    quill.insertEmbed(range.index, 'image', e.target.result);
                    setContent(prevContent => [...prevContent, { file, index: range.index }]);
                };
            }
        };
        input.click();
    };

    const VideoHandler = () => {
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'video/*');
        input.onchange = async () => {
            const file = input.files[0];
            if (file) {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = (e) => {
                    const range = quill.getSelection(true);
                    quill.insertEmbed(range.index, 'video', e.target.result);
                    setContent(prevContent => [...prevContent, { file, index: range.index }]);
                };
            }
        };
        input.click();
    };

    function sanitizeFileName(fileName) {
        return fileName
            .toLowerCase()
            .replace(/\s+/g, '_')            // Replace spaces with underscores
            .replace(/[^a-z0-9._-]/g, '')    // Remove invalid characters
            .replace(/_+/g, '_');            // Collapse multiple underscores
    }

    const handleSubmit = async () => {
        if (postTitle && prevImgFile) {
            setLoading(true)

            let previewImageUrl = '';
            if (prevImgFile) { // Assuming you store the File object in state when image is selected
                const previewPath = `images/en/${Date.now()}_${prevImgFile.name}`;
                const previewRef = storageRef(storage, previewPath);
                const previewSnapshot = await uploadBytes(previewRef, prevImgFile);
                previewImageUrl = await getDownloadURL(previewSnapshot.ref);
            }

            let contentHtml = quill.root.innerHTML;
            const promises = content.map(async (data) => {
                const storagePath = `images/en/${Date.now()}_${data.file.name}`;
                const imgRef = storageRef(storage, storagePath);
                const snapshot = await uploadBytes(imgRef, data.file);
                const url = await getDownloadURL(snapshot.ref);
                contentHtml = contentHtml.replace(`src="${data.file.name}"`, `src="${url}"`);
                return url;
            });

            await Promise.all(promises);

            const postRef = dbRef(db, 'posts/en');
            const newPostRef = push(postRef);
            await set(newPostRef, {
                postTitle: postTitle,
                imgPreview: previewImageUrl,
                content: contentHtml,
                timestamp: Date.now(),
            }).then(() => {
                setContent([]);
                setLoading(false)
                alert('Post added successfully!');
            }).catch(error => {
                setLoading(false)
                console.error('Error adding post: ', error);
            });
        } else {
            alert('Post title and preview image are empty.')
        }
    };

    const handleImageChange = (event) => {
        const file = event.target.files[0]; // Get the file from the event
        if (file && file.type.startsWith('image')) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setPrevImg(reader.result); // Set the read file URL to the state
                setPrevImgFile(file);
            };
            reader.readAsDataURL(file); // Read the file as a Data URL
        } else {
            setPrevImg(''); // Reset the preview if the file is not an image
            setPrevImgFile(null);
        }
    };

    return (
        <div>
            {loading && <div className='bkdrop' style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                backgroundColor: 'rgba(0,0,0,0.5)',
                zIndex: 1000,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}><CircularProgress sx={{ color: '#fff' }} /></div>}
            <button className='submit-post-button' onClick={handleSubmit} style={{
                display: 'inline-block',
                backgroundColor: '#0086a1',
                color: '#fff',
                padding: '5px 20px',
                fontSize: '13pt',
                border: 'none',
                marginBottom: '10px',
                marginRight: '30px',
                fontFamily: 'Arial',
                borderRadius: '10px',
                fontWeight: 'bold',
                boxShadow: '0px 0px 5px .5px gray',
            }}>Submit Post</button>
            <input type="text" placeholder='Post Title' onChange={(e) => { setPostTitle(e.target.value) }} style={{
                display: 'inline-block',
                fontSize: '13pt',
                padding: '5px 10px',
                outline: 'none',
                border: '2px solid #0086a1',
                borderRadius: '5px',
                width: '400px'
            }} />
            <input onChange={(e) => handleImageChange(e)} type="file" id='chooseimg' style={{ display: 'none' }} accept='images/*' />
            <label htmlFor="chooseimg" style={{ display: 'inline-block', fontSize: '13pt', fontFamily: 'Arial', backgroundColor: '#0086a1', color: 'white', padding: '5px 20px', cursor: 'pointer', marginLeft: '100px', borderRadius: '5px' }}>Choose Image</label>
            <img src={prevImg} alt="" style={{
                display: 'inline-block',
                height: '65px',
                marginLeft: '20px',
                position: 'fixed',
                top: '3px'
            }} />
            <div className='custom-quill' style={{
                minHeight: 'calc(100vh - 250px)'
            }} ref={quillRef} />
        </div>
    );
}


/* 
Experience the Best of KFMB at Gulfood 2023!


Kuwait Flour Mills & Bakeries (KFMB) isn't just a star in the world of baking; they are a comprehensive provider of high-quality food products. As the exclusive distributor of KFMB in the UAE, International Group Trading Co LLC proudly participated alongside KFMB at Gulfood 2023, the premier global food and beverage trade event. Visitors from all corners of the globe gathered to explore KFMB's diverse product categories.
KFMB booth, a focal point of the exhibition, was an expansive and inviting space equipped with state-of-the-art oven. The delightful aroma of freshly baked croissants and bread beckoned attendees to come and experience KFMB's exceptional flavors.
KFMB's participation in Gulfood 2023 was a celebration of their unwavering commitment to quality and innovation across various product categories, including frozen bakery, flour, pasta, bread, rusk, biscuits, gluten-free options, and ghee.
We were honored to have been part of this culinary journey and share these cherished moments with you. KFMB's extensive range of products promises something delicious for everyone.

Date: 20/02/2023


*/